<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-card card">
        <img src="../assets/logo.png" alt="El Shaday" class="login-logo" />
        <h1 class="login-title">Acamp Check-in</h1>
        <p class="login-subtitle">Entre com sua conta de administrador</p>

        <form @submit.prevent="handleSubmit" class="login-form">
          <div class="form-group">
            <label class="label" for="email">Email</label>
            <input id="email" class="input login-input" type="email" v-model="email" placeholder="admin@acamp.local" autocomplete="email" autocapitalize="none" autocorrect="off" inputmode="email" required />
          </div>
          <div class="form-group">
            <label class="label" for="password">Senha</label>
            <input id="password" class="input login-input" type="password" v-model="password" placeholder="••••••••" autocomplete="current-password" autocapitalize="none" autocorrect="off" required />
          </div>

          <button class="btn-primary login-btn" type="submit" :disabled="loading">
            <span v-if="!loading">Entrar</span>
            <span v-else>Entrando...</span>
          </button>
        </form>

        <p class="login-hint" v-if="hint">Em dev, registre via API: <code>POST /auth/register</code></p>
      </div>
    </div>
    <footer class="login-footer">
      <DevCredit />
    </footer>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth'
import DevCredit from '../components/ui/DevCredit.vue'

export default {
  name: 'LoginPage',
  components: { DevCredit },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      hint: true
    }
  },
  computed: {
    authStore() { return useAuthStore() }
  },
  mounted() {
    if (this.authStore.isAuthenticated) {
      this.$router.replace('/')
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      try {
        await this.authStore.login(this.email, this.password)
        this.$toast.open({ message: 'Bem-vindo(a)!', type: 'success', position: 'top-right', duration: 3000 })
        this.$router.push('/')
      } catch (err) {
        const msg = err.response?.data?.message || 'Erro ao fazer login'
        this.$toast.open({ message: msg, type: 'error', position: 'top-right', duration: 4000 })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  min-height: 100dvh; /* iOS Safari: usa dynamic viewport pra evitar overflow com URL bar */
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, var(--color-bg-body) 0%, #d4d4d4 100%);
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  box-sizing: border-box;
}
.login-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-base);
  box-sizing: border-box;
  width: 100%;
}
.login-footer {
  flex-shrink: 0;
  padding-bottom: 8px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: var(--spacing-xl);
  text-align: center;
  box-sizing: border-box;
}
.login-logo {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-circle);
  object-fit: cover;
  margin-bottom: var(--spacing-base);
}
.login-title {
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-sm);
}
.login-subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-bottom: var(--spacing-lg);
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  text-align: left;
  margin-bottom: var(--spacing-base);
}
.form-group {
  display: flex;
  flex-direction: column;
}
/* iOS Safari faz zoom em inputs com font-size < 16px. Forçar 16px aqui. */
.login-input {
  font-size: 16px !important;
}
.login-btn {
  justify-content: center;
  margin-top: var(--spacing-sm);
  width: 100%;
  padding: 14px 20px;
  font-size: var(--text-md);
}
.login-hint {
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin-top: var(--spacing-md);
  word-break: break-word;
}
.login-hint code {
  background: var(--color-bg-hover);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-family: monospace;
  font-size: 11px;
}

@media (max-width: 420px) {
  .login-content { padding: 12px; }
  .login-card { padding: var(--spacing-lg); }
  .login-logo { width: 60px; height: 60px; }
}
</style>
